import { useEffect } from 'react';
import ModernChatDialog from './ModernChatDialog';
import { useModernChatStore } from '../../../stores/modern-chat-store';
import { useAuth } from '../../../contexts/AuthContext';

interface ModernChatProps {
  playbookId: string;
  playbookName?: string;
}

export default function ModernChat({ playbookId, playbookName }: ModernChatProps) {
  const resetChatState = useModernChatStore((state) => state.resetChatState);
  const { user } = useAuth();

  useEffect(() => {
    // Reset ALL chat state when switching to a different playbook
    console.log(`🔄 Switching to playbook: ${playbookId} (${playbookName})`);
    resetChatState();
  }, [resetChatState, playbookId]); // Reset everything when playbook changes

  return (
    <div className="flex flex-col h-full bg-gradient-to-br from-gray-50 via-white to-gray-50">
      {/* Chat Container */}
      <div className="flex-1 flex relative overflow-hidden">
        <ModernChatDialog 
          playbookId={playbookId}
          playbookName={playbookName}
          userId={user?.sub}
        />
      </div>
    </div>
  );
} 